import api from "src/features/auth/axiosConfig";

export const getConfigurations = async (showDeleted: boolean) => {
  const res = await api.get(`/app/pos/v2/configuration?is_deleted=${showDeleted}`);
  return res.data.result;
};

export const addConfiguration = async (data: { conname: string; convalue: number }) => {
  return api.post(`/app/pos/v2/configuration`, data);
};

export const updateConfiguration = async (id: string, data: { conname: string; convalue: number }) => {
  return api.put(`/app/pos/v2/configuration/${id}`, data);
};

export const deleteConfiguration = async (id: string) => {
  return api.delete(`/app/pos/v2/configuration/${id}`);
};

